import { Head } from './Head';
import { MainStatic } from './Main';

type NotFoundProps = {
    troika?: boolean; // remove when troika is gone
};

export const NotFound = ({ troika }: NotFoundProps) => (
    <section className={troika ? 'panel' : 'p-16'}>
        <div className={troika ? 'u-text-center u-mv64' : 'text-center my-64'}>
            <h1>404</h1>
            <p>På FINN finner du alt … bortsett fra denne siden.</p>
            <p>
                <a href="https://www.finn.no/" data-testid="frontpageLink">
                    Gå til forsiden
                </a>
            </p>
        </div>
        <img
            style={{ maxWidth: '100%' }}
            src="https://www.finn.no/assets/404.jpg"
            alt="Katt som holder en FINN-annonse"
            data-testid="errorImage"
        />
    </section>
);

export const NotFoundPage = ({ troika }: NotFoundProps) => (
    <>
        {/* @ts-expect-error missing canonical as error page cannot have that, i.e. it can be shown for any url */}
        <Head title="404 | FINN reise" description="Vi kunne dessverre ikke finne denne siden." troika={troika} />
        <MainStatic className={troika ? 'no-focus-ring probably-not-touch' : undefined} troika={troika}>
            <NotFound troika={troika} />
        </MainStatic>
    </>
);
